<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>Import Users</glxy-page-title>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageTitle]="'USERS.TITLE' | translate"
        [previousPageUrl]="'/bc-admin'"
        [useHistory]="true"
        [historyBackButtonTitle]="'COMMON.ACTION_LABELS.BACK' | translate"
      ></glxy-page-nav-button>
    </glxy-page-nav>
  </glxy-page-toolbar>
  <glxy-page-wrapper [widthPreset]="'wide'">
    <mat-vertical-stepper
      class="mat-elevation-z0"
      #stepper
      [linear]="true"
      (selectionChange)="showUpdateUsersDetails = false"
    >
      <mat-step [stepControl]="fileForm">
        <form [formGroup]="fileForm">
          <ng-template matStepLabel>
            {{ 'USERS.BULK_IMPORT.UPLOAD_FILE_STEP.HEADER' | translate }}
          </ng-template>
          <div class="bottomMargin">
            <div>
              <div>
                {{ 'USERS.BULK_IMPORT.UPLOAD_FILE_STEP.INSTRUCTIONS_1' | translate }}
                <a (click)="downloadTemplate()" target="_blank">
                  <span>
                    {{ 'USERS.BULK_IMPORT.UPLOAD_FILE_STEP.DOWNLOAD_CSV_BUTTON' | translate }}
                  </span>
                </a>
              </div>
              <div>
                {{ 'USERS.BULK_IMPORT.UPLOAD_FILE_STEP.INSTRUCTIONS_2' | translate }}
                <ul class="instructions">
                  <li>
                    <strong>
                      {{ 'USERS.BULK_IMPORT.UPLOAD_FILE_STEP.REQUIRED_EMAIL_A' | translate }}
                    </strong>
                    {{ 'USERS.BULK_IMPORT.UPLOAD_FILE_STEP.REQUIRED_EMAIL_B' | translate }}
                  </li>
                  <li>
                    {{ 'USERS.BULK_IMPORT.UPLOAD_FILE_STEP.CSV_LIMIT' | translate }}
                  </li>
                  <li>
                    {{ 'USERS.BULK_IMPORT.UPLOAD_FILE_STEP.AGID_LIMIT' | translate }}
                  </li>
                </ul>
              </div>
              <div class="bottomMargin">
                {{ 'USERS.BULK_IMPORT.UPLOAD_FILE_STEP.INSTRUCTIONS_3' | translate }}
              </div>
            </div>
          </div>
          <div style="width: 400px">
            <mat-icon matSuffix class="attach-file-icon">attach_file</mat-icon>
            <input
              type="file"
              #removableInput
              formControlName="file"
              [accept]="'.csv'"
              placeholder="{{ selectFileText }}"
              (change)="fileOnChange($event)"
              required
            />
            <button
              mat-icon-button
              matSuffix
              *ngIf="!removableInput.empty"
              (click)="clearInput($event, removableInput)"
            >
              <mat-icon>clear</mat-icon>
            </button>
            <mat-error *ngIf="fileFormControl.hasError('required')">
              {{ 'USERS.BULK_IMPORT.ERRORS.FIELD_REQUIRED' | translate }}
            </mat-error>
          </div>
          <mat-spinner class="processing-spinner inline" *ngIf="fileProcessing" [diameter]="30"></mat-spinner>
          <div class="errorHeader" *ngIf="fileProcessingErrors">
            {{ 'USERS.BULK_IMPORT.UPLOAD_FILE_STEP.CSV_ERROR' | translate }}
          </div>
          <div class="errors" *ngFor="let err of fileProcessingError; index as i">
            <span class="errorRows">{{ fileProcessingErrorRows[i] }}</span>
            <span>{{ err }}</span>
            <span *ngIf="fileProcessingErrorOverflowShowHide[i] === 0">
              <a (click)="showMoreOrLess(i)">
                {{ 'USERS.BULK_IMPORT.UPLOAD_FILE_STEP.CSV_ERROR_EXPAND' | translate }}
                <mat-icon class="rowArrow">expand_more</mat-icon>
              </a>
            </span>
            <span *ngIf="fileProcessingErrorOverflowShowHide[i] === 1">
              <a (click)="showMoreOrLess(i)">
                {{ 'USERS.BULK_IMPORT.UPLOAD_FILE_STEP.CSV_ERROR_COMPRESS' | translate }}
                <mat-icon class="rowArrow">expand_less</mat-icon>
              </a>
            </span>
            <div class="allRows" *ngIf="fileProcessingErrorOverflowShowHide[i] === 1">
              {{ fileProcessingErrorOverflow[i] }}
            </div>
          </div>
          <div>
            <button
              class="nextBtn"
              mat-flat-button
              color="primary"
              (click)="goToUserListStep()"
              [disabled]="fileProcessingError?.length > 0"
            >
              {{ 'COMMON.ACTION_LABELS.NEXT' | translate }}
            </button>
          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="userListForm">
        <form [formGroup]="userListForm">
          <ng-template matStepLabel>
            {{ 'USERS.BULK_IMPORT.USER_LIST_STEP.HEADER' | translate }}
          </ng-template>
          <mat-radio-group formControlName="createNewList">
            <span *ngIf="userListList$ | async as lists">
              <span *ngIf="lists.length > 0">
                <mat-radio-button
                  value="{{ ct.USE_EXISTING_LIST }}"
                  [checked]="lists.length > 0"
                  color="primary"
                  (select)="useExistingList()"
                  (click)="useExistingList()"
                >
                  {{ 'USERS.BULK_IMPORT.USER_LIST_STEP.EXISTING_LIST' | translate }}
                </mat-radio-button>
                <div>
                  <span *ngIf="this.listBehavior === ct.USE_EXISTING_LIST">
                    <mat-form-field class="tabbed-in">
                      <mat-label>
                        {{ 'USERS.BULK_IMPORT.USER_LIST_STEP.SELECT_LIST' | translate }}
                      </mat-label>
                      <input type="text" matInput formControlName="selectList" [matAutocomplete]="userLists" />
                      <mat-autocomplete autoActiveFirstOption #userLists="matAutocomplete">
                        <mat-option
                          *ngFor="let list of filteredUserListList$ | async"
                          value="{{ list.userListName }}"
                          (onSelectionChange)="setListNameOption(list, $event)"
                        >
                          {{ list.userListName }}
                        </mat-option>
                      </mat-autocomplete>
                      <mat-error *ngIf="userListForm.controls['selectList'].hasError('required')">
                        {{ 'USERS.BULK_IMPORT.ERRORS.FIELD_REQUIRED' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </span>
                </div>
              </span>
              <mat-radio-button
                value="{{ ct.CREATE_NEW_LIST }}"
                [checked]="lists.length === 0"
                color="primary"
                (click)="createNewUserList()"
              >
                {{ 'USERS.BULK_IMPORT.USER_LIST_STEP.NEW_LIST' | translate }}
              </mat-radio-button>
              <div>
                <span *ngIf="listBehavior === ct.CREATE_NEW_LIST">
                  <mat-form-field class="tabbed-in">
                    <input
                      matInput
                      formControlName="userListName"
                      placeholder="List Name"
                      maxLength="255"
                      required
                      (keyup)="setListName($event)"
                    />
                    <mat-error *ngIf="userListForm.controls['userListName'].hasError('required')">
                      {{ 'USERS.BULK_IMPORT.ERRORS.FIELD_REQUIRED' | translate }}
                    </mat-error>
                    <mat-error *ngIf="userListForm.controls['userListName'].hasError('whitespace')">
                      {{ 'USERS.BULK_IMPORT.USER_LIST_STEP.LIST_NAME_ERROR' | translate }}
                    </mat-error>
                  </mat-form-field>
                </span>
              </div>
            </span>
            <mat-radio-button value="{{ ct.SKIP }}" color="primary" (click)="skipCreateUserLists()">
              {{ 'USERS.BULK_IMPORT.USER_LIST_STEP.SKIP' | translate }}
            </mat-radio-button>
          </mat-radio-group>
          <div>
            <button mat-stroked-button color="secondary" matStepperPrevious>
              {{ 'COMMON.ACTION_LABELS.BACK' | translate }}
            </button>
            <button class="nextBtn" mat-flat-button color="primary" (click)="goToFinalStep()">
              {{ 'COMMON.ACTION_LABELS.NEXT' | translate }}
            </button>
          </div>
        </form>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>
          {{ 'USERS.BULK_IMPORT.REVIEW_STEP.HEADER' | translate }}
        </ng-template>
        <div class="bottomMargin">
          <div>
            {{ userUploadInstructions }}
            <a (click)="navigateToManageUsers()">
              {{ 'USERS.LIST.TITLE' | translate }}
            </a>
            {{ 'USERS.BULK_IMPORT.UPLOAD_FILE_STEP.IMPORT_DETAILS_B' | translate }}
          </div>
          <mat-list>
            <mat-list-item>
              <mat-icon class="checkMark">done</mat-icon>
              <span class="reviewTitle">
                {{ 'USERS.BULK_IMPORT.REVIEW_STEP.CSV_FILE' | translate }}
              </span>
              <span class="">{{ csvFileName }}</span>
            </mat-list-item>
            <mat-divider></mat-divider>
            <mat-list-item>
              <mat-icon class="checkMark">done</mat-icon>
              <span class="reviewTitle">
                {{ 'USERS.BULK_IMPORT.REVIEW_STEP.TOTAL_IMPORT' | translate }}
              </span>
              <span class="">{{ rowTotalText }}</span>
            </mat-list-item>
            <mat-divider></mat-divider>
            <div *ngIf="this.listBehavior !== ct.SKIP">
              <mat-list-item>
                <mat-icon class="checkMark">done</mat-icon>
                <span class="reviewTitle">
                  {{ 'USERS.BULK_IMPORT.REVIEW_STEP.LIST_NAME' | translate }}
                </span>
                <span class="listName">{{ userListName }}</span>
              </mat-list-item>
              <mat-divider></mat-divider>
            </div>
            <mat-list-item>
              <mat-checkbox class="checkBox" [(ngModel)]="updateUsers">
                {{ 'USERS.BULK_IMPORT.REVIEW_STEP.UPDATE_USERS' | translate }}
              </mat-checkbox>
            </mat-list-item>
            <mat-list-item style="height: auto">
              <div class="updateUsers">
                <div>
                  {{ 'USERS.BULK_IMPORT.REVIEW_STEP.UPDATE_USERS_DESCRIPTION' | translate }}
                  <div>
                    <a *ngIf="!showUpdateUsersDetails" (click)="toggleUpdateUsersDetails()">
                      {{ 'COMMON.ACTION_LABELS.VIEW_DETAILS' | translate }}
                    </a>
                  </div>
                </div>
                <div *ngIf="showUpdateUsersDetails">
                  <ul class="updateUsersInfo">
                    <li>
                      {{ 'USERS.BULK_IMPORT.REVIEW_STEP.UPDATE_USERS_DETAILS_A' | translate }}
                    </li>
                    <li>
                      {{ 'USERS.BULK_IMPORT.REVIEW_STEP.UPDATE_USERS_DETAILS_B' | translate }}
                    </li>
                    <li>
                      {{ 'USERS.BULK_IMPORT.REVIEW_STEP.UPDATE_USERS_DETAILS_C' | translate }}
                    </li>
                  </ul>
                  <a *ngIf="showUpdateUsersDetails" (click)="toggleUpdateUsersDetails()">
                    {{ 'COMMON.ACTION_LABELS.VIEW_LESS' | translate }}
                  </a>
                </div>
              </div>
            </mat-list-item>
          </mat-list>
        </div>
        <mat-error *ngIf="importErrorMessage">
          <mat-icon>error</mat-icon>
          <span class="errorText">{{ importErrorMessage }}</span>
        </mat-error>
        <div>
          <button mat-stroked-button color="secondary" matStepperPrevious>
            {{ 'COMMON.ACTION_LABELS.BACK' | translate }}
          </button>
          <div class="submitButton">
            <button mat-flat-button color="primary" type="submit" (click)="startListImport()" [disabled]="loading">
              <mat-spinner
                class="submitButton processing-spinner"
                *ngIf="loading"
                [diameter]="30"
                style="margin: 3.5px 0px"
              ></mat-spinner>
              <span *ngIf="!loading">
                {{ 'COMMON.ACTION_LABELS.FINISH' | translate }}
              </span>
            </button>
            <span class="info-message">
              {{ 'USERS.BULK_IMPORT.REVIEW_STEP.IMPORT_WARNING' | translate }}
            </span>
          </div>
        </div>
      </mat-step>
    </mat-vertical-stepper>
  </glxy-page-wrapper>
</glxy-page>
